import {ArtfactKind, IEntity, Metadata, Search} from '@mrp-brasil/nick-data-commons';
import {ICoreCrudService} from '@mrp-brasil/nick-node-commons';
import {BaseHook, Hook, HookClass, NickProcessArtfact} from '@mrp-brasil/nick-process-commons';
import {from, Observable, of} from 'rxjs';
import {concatMap, flatMap, map, toArray} from 'rxjs/operators';


@HookClass('geo')
export class GeoHook extends BaseHook {
    @Hook('659dfcab-fe3e-4e49-ba22-a208d3f9680b')
    public findGeoLocation(inputArtifact: NickProcessArtfact): Observable<NickProcessArtfact> {
        return this.service('ModelDbXrefGeoService')
            .pipe(concatMap((service: any) => {
                const modelQueryId = inputArtifact.object.modelQueryId;
                const lat = [inputArtifact.object.config.startLat, inputArtifact.object.config.endLat];
                const long = [inputArtifact.object.config.startLong, inputArtifact.object.config.endLong];
                const radius = inputArtifact.object.config.radius;
                const search = new Search(inputArtifact.object.data, '$and');

                return service.findNearbyArrayByQuery(modelQueryId, lat, long, radius, search);
            })).pipe(map((entities: IEntity[]) => {
                inputArtifact.object.data = entities.map((entity: IEntity) => entity && entity.toJSON ? entity.toJSON() : entity);
                return inputArtifact;
            }));
    }

    @Hook('e3bc7219-5dcc-48db-807c-1c9fa0c7343c')
    public nearbyByQuery(inputArtifact: NickProcessArtfact): Observable<NickProcessArtfact> {
        return this.service('ModelDbXrefGeoService')
            .pipe(concatMap((service: any) => {
                const modelQueryId = inputArtifact.object.modelQueryId;
                const lat =inputArtifact.object.config.lat;
                const long = inputArtifact.object.config.long;
                const distance = inputArtifact.object.config.distance;
                const search = new Search(inputArtifact.object.data, '$and');

                return service.findNearbyByQuery(modelQueryId, lat, long, distance, search);
            })).pipe(map((entities: IEntity[]) => {
                inputArtifact.object.data = entities.map((entity: IEntity) => entity && entity.toJSON ? entity.toJSON() : entity);
                return inputArtifact;
            }));
    }
}
